module.exports = __webpack_public_path__ + "img/icon_exchange_30people.ecb3879a.png";